export const ROUTES = {
  financialData: {
    page: '/database/financial-data',
    companyChart: '/database/financial-data/:dataset/:dbVersion/:companyUid/connections',
    ownershipChart:
      '/database/financial-data/:dataset/:dbVersion/:companyUid/ownership-connections',
    company: '/database/financial-data/:dataset/:dbVersion/:companyUid',
    legacyCompanyChart: '/database/financial-data/:companyUid/connections',
    legacyOwnershipChart: '/database/financial-data/:companyUid/ownership-connections',
    legacyCompany: '/database/financial-data/:companyUid',
  },
  mySearches: {
    page: '/database/my-searches',
  },
  allSearches: {
    page: '/database/all-searches',
  },
  help: {
    page: '/database/help',
  },
  benchmarking: {
    page: '/database/benchmark',
    benchmark: '/database/benchmark/:benchmarkId',
    benchmarkTab: '/database/benchmark/:benchmarkId/:tabName',
    benchwise: '/database/compidai',
    benchwiseStudyList: '/database/compidai/my-studies',
    refinementCompany: '/database/benchmark/:benchmarkId/refinement/:companyUid',
    connections: '/database/benchmark/:benchmarkId/:companyUid/connections',
    ownership: '/database/benchmark/:benchmarkId/:companyUid/ownership-connections',
  },
  externalLinks: {
    prod: {
      royaltySearch: 'https://database.royaltyrange.com/royalty/search/new',
      serviceSearch: 'https://database.royaltyrange.com/service/search/new',
      loanSearch: 'https://database.royaltyrange.com/loan/search/new',
      dempeAnalitics: 'https://database.royaltyrange.com/dempe/view',
      creditRatingTool: 'https://database.royaltyrange.com/credit-rating/calc',
      benchmarkingTool: 'https://database.royaltyrange.com/benchmark',
      pillars: 'https://beps.royaltyrange.com/',
    },
    demo: {
      royaltySearch: 'https://database-demo.royaltyrange.com/royalty/search/new',
      serviceSearch: 'https://database-demo.royaltyrange.com/service/search/new',
      loanSearch: 'https://database-demo.royaltyrange.com/loan/search/new',
      dempeAnalitics: 'https://database-demo.royaltyrange.com/dempe/view',
      creditRatingTool: 'https://database-demo.royaltyrange.com/credit-rating/calc',
      benchmarkingTool: 'https://database-demo.royaltyrange.com/benchmark',
      pillars: 'https://beps-demo.royaltyrange.com/',
    },
  },
};
